import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryCountryListResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setCountryList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryCountryListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(INVENTORY_MODULE?.COUNTRY_LIST?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryCountryListResponse>) => {
          if (res.data.status === true) {
            dispatch(setCountryList({ data: res.data.data }));
          } else {
            dispatch(setCountryList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
